import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

interface ProductCategory {
  id: number;
  title: string;
}

interface Product {
  id: number;
  title: string;
  description: string;
  duration_text: string;
  price: number;
  view_order: number;
  tag: string;
  product_category: ProductCategory;
}

interface CardState {
  card: Product[];
  loading: boolean;
  error: string | null;
}

const initialState: CardState = {
  card: [],
  loading: false,
  error: null,
};

export const getCard = createAsyncThunk<Product[], number>(
  "card/getCard",
  async (categoryId) => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/products`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data: Product[] = await response.json();
    // const cards = data.filter(
    //   (product) => product.product_category.id === categoryId
    // );
    return data;
  }
);

const cardSlice = createSlice({
  name: "card",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCard.fulfilled, (state, action: PayloadAction<Product[]>) => {
        state.loading = false;
        state.card = action.payload;
      })
      .addCase(getCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Unknown error";
      });
  },
});

export default cardSlice.reducer;
